import create from 'zustand';

type MenuOpenStore = {
  count: number;
};

const defaultState: MenuOpenStore = {
  count: 0,
};

const useStore = create<MenuOpenStore>(() => defaultState);

export const menuOpenStore = {
  useStore,
  increment: () => useStore.setState((s) => ({ count: s.count + 1 })),
  decrement: () => useStore.setState((s) => ({ count: Math.max(0, s.count - 1) })),
  useIsAnyMenuOpen: () => useStore((s) => s.count > 0),
};
